import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";

// V1 (legacy)
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Collections from "@/pages/Collections";
import Designer from "@/pages/Designer";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Faqs from "@/pages/Faqs";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Admin from "@/pages/Admin";

// V2 (primary)
import V2Layout from "@/v2/Layout";
import V2Home from "@/v2/pages/Home";
import V2Collections from "@/v2/pages/Collections";
import V2ProductDetail from "@/v2/pages/ProductDetail";
import V2Custom from "@/v2/pages/Custom";
import V2About from "@/v2/pages/About";
import V2Contact from "@/v2/pages/Contact";
import V2Journal from "@/v2/pages/Journal";
import V2Policy from "@/v2/pages/Policy";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<Admin />} />

            {/* Primary site — V2 editorial design */}
            <Route element={<V2Layout />}>
              <Route path="/" element={<V2Home />} />
              <Route path="/collections" element={<V2Collections />} />
              <Route path="/product/:id" element={<V2ProductDetail />} />
              <Route path="/custom" element={<V2Custom />} />
              <Route path="/about" element={<V2About />} />
              <Route path="/contact" element={<V2Contact />} />
              <Route path="/journal" element={<V2Journal />} />
              <Route path="/policies/:slug" element={<V2Policy />} />
              <Route path="/faqs" element={<Faqs />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order/:id" element={<OrderConfirmation />} />
            </Route>

            {/* Back-compat: redirect old /v2/* URLs to root */}
            <Route path="/v2" element={<Navigate to="/" replace />} />
            <Route path="/v2/*" element={<Navigate to="/" replace />} />

            {/* Legacy V1 design — kept as backup */}
            <Route path="/legacy" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="collections" element={<Collections />} />
              <Route path="designer" element={<Designer />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="about" element={<About />} />
              <Route path="contact" element={<Contact />} />
              <Route path="faqs" element={<Faqs />} />
              <Route path="product/:id" element={<ProductDetail />} />
              <Route path="checkout" element={<Checkout />} />
              <Route path="order/:id" element={<OrderConfirmation />} />
            </Route>

            {/* Catch-all — anything unknown returns to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
